"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Compass, Target, Zap } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TiposDeSesiones() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const sessions = [{
    icon: Compass,
    title: "Sesión de exploración (gratuita)",
    description: "Perfecta para comenzar.\n\nExploramos tu situación actual, qué te está bloqueando y qué necesitas ahora mismo.\nSin compromiso y sin presión.\n\nEsta sesión nos permite ver si el coaching es para ti y si tiene sentido avanzar juntos.",
    cta: "Reservar sesión gratuita"
  }, {
    icon: Target,
    title: "Proceso de coaching",
    description: "Un acompañamiento profundo y personalizado.\n\nSi después de la sesión de exploración decides continuar, iniciamos un proceso de coaching adaptado a ti.\nNo trabajamos por sesiones sueltas, sino por proceso.\n\nSin límite cerrado de sesiones, a tu ritmo y con foco en avanzar de verdad.",
    cta: "Reservar sesión gratuita"
  }, {
    icon: Zap,
    title: "Seguimiento y claridad",
    description: "Para sostener el cambio.\n\nCada sesión está orientada a ganar claridad, romper bloqueos y mantener los avances en el tiempo.\nNo se trata solo de hablar, sino de integrar cambios reales en tu día a día.",
    cta: "Reservar sesión gratuita"
  }];
  const refs = [ref1, ref2, ref3];
  const visibles = [isVisible1, isVisible2, isVisible3];
  return <section className="bg-light-background py-16 px-6 md:px-12 lg:px-20">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-3xl font-semibold text-foreground-light md:text-4xl">
            Tipos de sesiones
          </h2>
          <p className="mt-4 text-base text-muted-foreground md:text-lg">
            Cada sesión está diseñada para acompañarte en un momento específico de tu proceso personal.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {sessions.map((session, i) => {
          const Icon = session.icon;
          return <div key={i} data-index={i} ref={refs[i]} className={`transition-all duration-[var(--duration-slow)] ${visibles[i] ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="flex h-full flex-col bg-muted-light-background shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium">
                  <CardHeader className="pb-4">
                    <div className="mb-3 flex size-12 items-center justify-center rounded-md bg-primary/10 transition-colors duration-[var(--duration-medium)] group-hover:bg-primary/20">
                      <Icon className="size-6 text-primary transition-colors duration-[var(--duration-medium)] hover:text-accent" />
                    </div>
                    <CardTitle className="text-xl font-semibold text-foreground-light">
                      {session.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-1 pb-4">
                    <CardDescription className="text-sm leading-relaxed text-muted-foreground">
                      {session.description}
                    </CardDescription>
                  </CardContent>
                  <CardFooter>
                    <Link to="/ContactReserveSessionPage">
                      <Button variant="secondary" size="default" className="w-full">
                        {session.cta}
                      </Button>
                    </Link>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}